import React from 'react';

import Features from '@dashboard/enums/features';
import usePage from '@dashboard/hooks/usePage';

import CanUseFeature from '@dashboard/components/CanUseFeature';
import Link from '@dashboard/components/Link';

import PageEditView from '../../components/PageEditView';
import PageFieldsForm from '../../components/PageFieldsForm';

import DiscountCodeForm from '../../scenes/PageSettings/components/DiscountCodeForm';
import LimitSubscriptionsForm from '../../scenes/PageSettings/components/LimitSubscriptionsForm';
import PaymentMethodsForm from '../../scenes/PageSettings/components/PaymentMethodsForm';

import FeesForm from './components/FeesForm';
import PaymentOptionsForm from './components/PaymentOptionsForm';
import SettingsPageStripeTax from './components/SettingsPageStripeTax';

const PageCheckout = () => {
  const { page } = usePage();

  return (
    <PageEditView
      tabs={[
        {
          path: '/checkout-fields',
          label: 'Checkout fields',
          component: <PageFieldsForm />,
          description: (
            <>
              Capture customer information & preferences.{' '}
              <Link to="/help/articles/how-to-add-custom-fields" blank>
                Learn more
              </Link>
            </>
          ),
        },
        {
          path: '/discount-code',
          label: 'Discount code',
          component: <DiscountCodeForm />,
          description: <>Allow customers to enter a discount code.</>,
        },
        ...(page.productType !== 'subscription'
          ? [
              {
                path: '/manual-payments',
                label: 'Manual payments',
                description: (
                  <>
                    Choose how customers can pay for their order: pay in full, pay by invoice, pay a
                    deposit, or pay cash on delivery.
                  </>
                ),
                component: (
                  <CanUseFeature feature={Features.MANUAL_PAYMENTS}>
                    <PaymentOptionsForm />
                  </CanUseFeature>
                ),
              },
            ]
          : []),
        {
          path: '/payment-methods',
          label: 'Payment methods',
          component: <PaymentMethodsForm />,
          description: (
            <>
              Select the payment methods you want to add to your checkout.{' '}
              <Link to="/help/payment-methods" target="_blank">
                Learn more
              </Link>
            </>
          ),
        },
        {
          path: '/fees-surchages',
          label: 'Fees & surcharges',
          description:
            'Charge additional fees for payment processing, handling, shipping and more.',
          component: (
            <CanUseFeature feature={Features.CUSTOM_FEES}>
              <FeesForm />
            </CanUseFeature>
          ),
        },
        {
          path: '/stripe-tax',
          label: 'Stripe Tax',
          component: <SettingsPageStripeTax />,
          description: (
            <>
              Automatically calculate and collect tax on your sales. You must at least add a country
              field to start collecting tax. <Link to="/settings/stripe-tax">Learn more</Link>
            </>
          ),
        },
        ...(page.productType === 'subscription'
          ? [
              {
                path: '/limits',
                label: 'Limits',
                component: <LimitSubscriptionsForm />,
              },
            ]
          : []),
      ]}
    />
  );
};

export default PageCheckout;
